import { createVNode, render as vueRender, nextTick } from 'vue'
import { isClient } from '@vueuse/core'
import MinimizeBox from './minimize-box.vue'

import type { VNode } from 'vue'

type MinimizeQueueItem = {
  props?: any
  onRestore?: () => void
  onClose?: () => void
  onHide?: () => void
}

type MinimizeQueue = MinimizeQueueItem[]

let instances: MinimizeQueue = []
// let scrollWrap

// const container = document.createElement('div')
const className = 'sg-modal-minimize-wrap'

let currentConfig = {
  visible: false,
  list: []
}

let scrollWrap: VNode|null = null

const Wrapper = (props) => {
  return createVNode(
    'div',
    {
      class: [
        className,
      ],
      style: {
        display: props.visible ? null : 'none'
      }
    },
    props.list.map((item) => {
      const { id, title, closable } = item.props

      return createVNode(
        MinimizeBox,
        {
          title,
          closable,
          onRestore: () => {
            hide(id)
            item.onRestore && item.onRestore()
          },
          onClose: () => {
            hide(id)
            item.onClose && item.onClose()
          }
        }
      )
    })
  )
}

function init() {
  const container = document.createElement('div')
  const appendTo: HTMLElement | null = document.body

  if (appendTo.getElementsByClassName(className).length) {
    return scrollWrap
  }

  const vnode = createVNode(Wrapper, { ...currentConfig })

  vueRender(vnode, container)

  appendTo.appendChild(container.firstElementChild!)

  return vnode
}

function update(configUpdate) {
  if (typeof configUpdate === 'function') {
    currentConfig = configUpdate(currentConfig)
  } else {
    currentConfig = {
      ...currentConfig,
      ...configUpdate,
    }
  }

  if (scrollWrap) {
    nextTick(() => {
      Object.assign(scrollWrap!.component!.props, currentConfig)
      scrollWrap!.component!.update()
    })
  }
}

function hide(id) {
  for (let i = 0; i < instances.length; i++) {
    const item = instances[i]
    if (item.props.id === id) {
      item.onHide && item.onHide()
      instances.splice(i, 1)
      break
    }
  }

  if (instances.length === 0) {
    update({ list: [], visible: false })
  } else {
    update({ list: instances })
  }
}

// function destroy() {
//   if (scrollWrap) {
//     vueRender(null, container)
//     scrollWrap.component!.update()
//     scrollWrap = null
//   }
// }

if (isClient) {
  scrollWrap = init()
}

export function createMinimize(options) {
  const { onRestore, onClose, onHide, ...props } = options

  instances.push({ props, onRestore, onClose, onHide })

  update({ list: instances, visible: true })
}

export const removeMinimize = hide
